import { gql } from "@apollo/client";

export const GET_JOBS = gql`
  query jobsByOrg($orgId: Int!) {
    jobsByOrg(orgId: $orgId) {
      jobId
      jobTitle
      department
      jobType
      position
      minBudget
      maxBudget
      minExp
      maxExp
      client
      travelReq
      experience
      location
      description
      attachment
      orgId
      noticePeriod
      skills
      recruiter
      status
      createDate
      vacancies
      priority
      workType
      comment
      priceType
      subvendorId
      attachment
      responsibilities
      eligibility
      Questionnaires
      isBoolean
      process {
        Id
        JobId
        applicantId
        recruiterId
        usernames {
          userId
          firstName
          lastName
        }
        jobtitles {
          jobId
          jobTitle
          client
          recruiter
        }
        applicantDetails {
          applicantId
          firstName
          lastName
          email
          phone
          gender
          address
          linkedInUrl
          interviewStatus
          orgId
          jobIds
        }
        createdAt
      }
      recruiterDetails {
        firstName
        lastName
        userId
      }
    }
  }
`;



export const GET_JOB = gql`
  query job($jobId: String) {
    job(jobId: $jobId) {
      jobId
      jobTitle
      department
      jobType
      position
      minBudget
      maxBudget
      minExp
      maxExp
      client
      travelReq
      experience
      country
      location
      description
      attachment
      orgId
      noticePeriod
      skills
      recruiter
      attachment
      Questionnaires
      responsibilities
      eligibility
      process {
        Id
        JobId
        applicantId
        recruiterId
        mappedBy
        usernames {
          userId
          firstName
          lastName
        }
        interviewData {
          status
        }
        jobtitles {
          jobId
          jobTitle
          client
          recruiter
        }
        applicantDetails {
          applicantId
          firstName
          lastName
          email
          phone
          gender
          address
          linkedInUrl
          interviewStatus
          orgId
          jobIds
        }
        createdAt
      }
      recruiterDetails {
        firstName
        lastName
        userId
      }
      status
      createDate
      vacancies
      priority
      workType
      comment
      priceType
      subvendorId
      clientDetails {
        name
      }
      subVendorDetails {
        vendorName
      }
      deptDetails {
        name
      }
    }
  }
`;



export const CREATE_JOB = gql`
  mutation CreateJob($input: createJobInput) {
    createJob(input: $input) {
      jobId
      skills
    }
  }
`;

export const UPDATE_JOB = gql`
  mutation updateJob($input: updateJobInput) {
    updateJob(input: $input)
  }
`;



export const JOB_PUBLIC = gql`
  query JobPublic($jobId: String) {
    jobPublic(jobId: $jobId) {
      description
      jobTitle
      skills
      attachment
      Questionnaires
      jobId
      jobType
      travelReq
      workType
      maxBudget
      minBudget
      location
      position
      recruiter
      recruiterDetails {
        firstName
      }
      createDate
      minExp
      maxExp
      client
      clientDetails {
        name
      }
      noticePeriod
      priority
      status
      department
      deptDetails {
        name
      }
      orgLogo {
        logo
      }
      responsibilities
    }
  }
`;



